export const GET_TOTAL_STATS = 'BILLS/get_total_stats';
export const GET_GRAPH_STATS = 'BILLS/get_graph_stats';
export const GET_YEAR_LIST = 'COLLECTION/GET_YEAR_LIST';

export const COLORS = [
    '#A3B3F9',
    '#B1CDF8',
    '#BBE9FE',
    '#5272AA',
    '#84DAFF',
];

export const E_WALLET = [
    { name: 'Bills Payment', color: '#A3B3F9', value: 0 },
    { name: 'Cash-In', color: '#B1CDF8', value: 0 },
    { name: 'Cash Transfer', color: '#BBE9FE', value: 0 },
    { name: 'Mobile Load', color: '#5272AA', value: 0 },
    { name: 'Receive Cash', color: '#84DAFF', value: 0 },
  ];